<template>
    <div :id="componentId">
        <b-btn 
        :id="reactiveId" 
        :ref="buttonRef" 
        style="color: #2c3e50; cursor: pointer; border: 1px solid #dcdfe6; outline: none; background-color: #ffffff">
            <i class="fas fa-file-alt fa-lg"></i>
        </b-btn>
        <b-popover
            :target="reactiveId"
            :triggers="'click'"
            :show.sync="popoverShow"
            placement="bottom"
            :container="componentId"
            ref="popoverId"
            @show="onShow"
            @shown="onShown"
            @hidden="onHidden"
            @hide="onHide"
        >
            <template slot="title"></template>
            <div class="table-button-group" :ref="focusRefId">
                <b-button 
                    v-b-tooltip.hover 
                    :title="$t('upload')" 
                    size="sm" v-if="showUpload && onCloud"
                >
                    <file-upload
                        class="pt-2"
                        style="padding:0; margin-bottom: 0;"
                        :ref="componentId"
                        v-model="newFiles"
                        @input-file="inputFile"
                        :input-id="componentId + 'popover_upload'"
                    >
                        <i class="fas fa-upload fa-lg"></i>
                    </file-upload>
                </b-button>
                <b-button
                    v-b-tooltip.hover 
                    :title="$t('upload')" 
                    size="sm" v-if="showUpload && !onCloud"
                >
                    <file-upload
                        :ref="componentId"
                        v-model="newFiles"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        :input-id="componentId + 'popover_upload'"
                        chunk-enabled
                        :chunk="{
                            headers: { Authorization: token},
                            action: action,
                            minSize: 0,
                            maxActive: 3,
                            maxRetries: 5,
                            startBody: {
                                filename: newFiles.length ? newFiles[0].name : null
                            }
                        }"
                        class="btn"
                        style="padding:0; margin-bottom: 0;"
                    >
                        <i class="fas fa-upload fa-lg"></i>
                    </file-upload>
                </b-button>
                <b-button 
                    v-show="showDelete"
                    v-b-tooltip.hover 
                    @click="onRemove" 
                    :title="$t('delete')" 
                    size="sm" 
                    variant="danger"
                >
                    <i class="fas fa-trash-alt fa-lg"></i>
                </b-button>
                <b-button 
                    v-if="showDownload" 
                    v-b-tooltip.hover 
                    @click="$emit('ondownload')" 
                    :title="$t('download')" 
                    size="sm"
                >
                    <i class="fas fa-download fa-lg"></i>
                </b-button>
            </div>
        </b-popover>

    </div>
</template>

<script>
import uuidV4 from 'uuid/v4';
import _ from 'lodash';
let componentID = uuidV4();
export default {
    name: 'upload',
    props: {
        reactiveId: {
            default: () => null
        },
        showUpload: {
            default: () => true
        },
        showDownload: {
            default: () => true
        },
        showDelete: {
            default: () => true
        },
        showPopover: {
            default: () => true
        },
        uploadOnCloud: {
            type: Boolean,
            default: () => null
        },
        fileCategory: {
            type: String,
            default: () => 'other'
        },
        deleteFromDB: {
            type: Boolean,
            default: () => false
        },
        dataId: {
            default: () => null
        },
    },
    data() {
        return {
            componentId: `a_${uuidV4()}`,
            popoverId: `${componentID}_popover`,
            buttonRef: `${componentID}_button`,
            focusRefId: `${componentID}_focus`,
            newFiles: [],
            action: null,
            popoverShow: false,
            onCloud: false
        };
    },
    methods: {
        inputFile: function(newFile, oldFile) {
            if(this.deleteFromDB && this.dataId && this.onCloud){
                this.axios.delete(`/deleteFromAws/${this.dataId}`);
            }
            if(this.onCloud){
                let file = _.head(this.newFiles) && _.head(this.newFiles).file;
                if(file){
                    let FR = new FileReader();
                    FR.readAsDataURL(file);
                    FR.onload = event => {
                        return this.axios.post(`/uploadToAws`, {
                            data: event.target.result,
                            type: this.fileCategory,
                            mimeType: _.get(file, 'type'),
                            size: _.get(file, 'size'),
                            originalFileName: _.get(file, 'name'),
                            userIdOverWrite: _.get(this.$store.state.user, 'id')
                        }).then(({data})=>{
                                this.$emit('onupload', {
                                    id: data.id,
                                    fileUrl: data.url,
                                    filename: data.filename,
                                    fileId: data.fileId,
                                    status: 'success',
                                    onCloud: this.onCloud
                                });
                            })
                    };
                }
            }
            else{
                // Upload file immediately
                if (newFile && !newFile.active && !oldFile) {
                    newFile.active = true; // when set true, upload progress will be start.
                }
                // Get response data
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    this.$emit('onupload', {...newFile.response, onCloud:this.onCloud});
                    this.popoverShow = false;
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status);
                    }
                }
            }
        },
        inputFilter: function(newFile) {
            newFile.blob = '';
            let URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }
        },
        onRemove() {
            if(this.deleteFromDB && this.dataId && this.onCloud){
                return this.axios.delete(`/deleteFromAws/${this.dataId}`)
                    .then(()=>{
                            this.$emit('onremove');
                            this.popoverShow = false;
                        });
            }else{
                this.$emit('onremove');
                this.popoverShow = false;
            }
        },
        onClose() {
            this.popoverShow = false;
        },
        onHide() {
            this.popoverShow = false;
        },
        onShow() {
            /* This is called just before the popover is shown */
            /* Reset our popover "form" variables */
        },
        onShown() {
            /* Called just after the popover has been shown */
            /* Transfer focus to the first input */
            this.focusRef(this.$refs[this.focusRefId]);
        },
        onHidden() {
            /* Called just after the popover has finished hiding */
            /* Bring focus back to the button */
            //this.focusRef(this.$refs[this.buttonRef]);
        },
        focusRef(ref) {
            /* Some references may be a component, functional component, or plain element */
            /* This handles that check before focusing, assuming a focus() method exists */
            /* We do this in a double nextTick to ensure components have updated & popover positioned first */
            this.$nextTick(() => {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            });
        }
    },
    watch: {
        newFiles(newVal) {
            this.$store.state.uploadFiles = newVal;
        }
    },
    created() {
        this.action = `${this.apiURL}/upload`;
        this.onCloud = this.uploadOnCloud != null ? this.uploadOnCloud : !(this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId));
    }
};
</script>

<style lang="scss" scoped>
.close {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
}
</style>

<i18n src="../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/Upload.vue